declare global {
    interface Window {
        Trustpilot?: NTrustPilot.Api;
    }
}

export namespace NTrustPilot {
    export const SCRIPT = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

    export interface Api {
        loadFromElement(element: HTMLElement): void;
        Modules?: {
            WidgetManagement?: IWidgetManagementModule;
        };
    }

    export interface IWidgetManagementModule {
        widgets?: IWidget[];
    }

    export interface IWidget {
        container?: HTMLElement;
    }
}
